import styled from 'styled-components';

export const PageWidthContainer = styled.div`
  /*  We expect the coloured background to stretch the full width of the view.left
      However, the parent container has a max-width, so we must stretch the container using
      a negative margin and then pad that section of the div.
  */
  padding: 0 calc((100vw - 100%) / 2);
  margin: 0 calc((100% - 100vw) / 2);
`;
